export class AntennaType {

  constructor(
    public Id: string,
    public Label: string,
  ) {
  }
}
